const HEADER_HEIGHT = 48;

export { HEADER_HEIGHT };
